import {View} from 'react-native';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {Text, ActionButton} from '~/components/controls';
import Actionsheet, {
  Title,
  Content,
  Actions,
} from '~/components/controls/Actionsheet';
import Format from '~/lib/format';

const LENIENCY_LABELS = {
  LeniencyRequested: 'Aangevraagd',
  LeniencyResolved: 'Afgewikkeld',
  LeniencyDenied: 'Afgewezen',
};

export default ({visible, onDismiss, value, task_amount}) => {
  return (
    <>
      <Actionsheet visible={visible} onDismiss={onDismiss} dismissable={false}>
        <Title>Coulance</Title>
        <Divider style={sy['bg-gray88']} />
        <Content style={{paddingBottom: 0, paddingHorizontal: 0}}>
          <View
            style={[
              sy['p-4'],
              sy['flex-row'],
              sy['items-center'],
              sy['justify-between'],
            ]}>
            <Text style={sy.mediumPlus}>Status</Text>
            <Text>{LENIENCY_LABELS[value]}</Text>
          </View>
          <View
            style={[
              sy['p-4'],
              sy['flex-row'],
              sy['items-center'],
              sy['justify-between'],
            ]}>
            <Text style={sy.mediumPlus}>Bedrag</Text>
            <View
              style={{
                padding: 5,
                backgroundColor: '#F2F2F2',
                borderRadius: 2,
              }}>
              <Text style={[sy.small]}>{Format.price(task_amount ?? 0)}</Text>
            </View>
          </View>
        </Content>
        <Divider style={sy['bg-gray88']} />
        <Actions>
          <ActionButton onPress={onDismiss}>OK</ActionButton>
        </Actions>
      </Actionsheet>
    </>
  );
};
